import { useCallback, useEffect, useState } from 'react';

export const useSticky = (stickyCheck: () => boolean) => {
    const [isSticky, setIsSticky] = useState(true);

    const updateSticky = useCallback(() => {
        const stickyChecked = stickyCheck();

        setIsSticky(stickyChecked);
    }, [stickyCheck]);

    useEffect(() => {
        updateSticky();

        window.addEventListener('scroll', updateSticky);
        window.addEventListener('resize', updateSticky);

        return () => {
            window.removeEventListener('scroll', updateSticky);
            window.removeEventListener('resize', updateSticky);
        };
    }, [updateSticky]);

    return isSticky;
};
